import React, { useState, useCallback } from "react";

import { Input } from "@treelab/panda";

import { ITypeOptions, ColumnType } from "../../../../../../types/table-type";
import { IFilterValue } from "../../../../../../types/form-type";

import {
  getFormattedCurrency,
  isInvalidTypedCharForInput,
  parseStringToFloat,
} from "../../../../../../utils/filter_secondary";

interface IProps {
  name: string;
  onChange: (value: { [key: string]: any }) => void;
  typeOptions: ITypeOptions<ColumnType.CURRENCY>;
  value: IFilterValue;
}

const CurrencyInput: React.FC<IProps> = ({ name, onChange, typeOptions, value }) => {
  const currentSymbol = typeOptions.currencyFormat;
  const [inputValue, setInputValue] = useState(getFormattedCurrency(value.filterString, typeOptions));

  const handleKeydown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (isInvalidTypedCharForInput(e, currentSymbol)) {
        e.preventDefault();
      }
    },
    [currentSymbol]
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(e.target.value);
      const parsedValue = parseStringToFloat(e.target.value);
      onChange({ filterString: parsedValue });
    },
    [onChange]
  );

  const handleBlur = useCallback(
    (e) => {
      const parsedValue = parseStringToFloat(inputValue || "");
      onChange({ filterString: parsedValue });
      setInputValue(getFormattedCurrency(value.filterString, typeOptions));
    },
    [inputValue, onChange, typeOptions, value.filterString]
  );

  return (
    <Input.Text
      input={{
        name,
        onBlur: handleBlur,
        onChange: handleChange,
        value: inputValue || "",
      }}
      meta={{}}
      onKeyDown={handleKeydown}
    />
  );
};

export default CurrencyInput;
